import React from 'react'
import { AggregateListItem, Divider, InfoBox, List, ListSubheader } from '../../../../../views/components'
import { formatCurrency } from 'utils/currency'
import styles from './PortfolioRenewalForm.module.scss'

interface NextStepsProps {
  isImmediate: boolean
  rentAmount: number
  managementFeeLabel: string
  managementFeeText: string
  renewalFee: number
  depositTopUp: number
  showDepositTopUp: boolean
}

const NextSteps = ({
  isImmediate,
  rentAmount,
  managementFeeLabel,
  managementFeeText,
  renewalFee,
  depositTopUp,
  showDepositTopUp,
}: NextStepsProps) => {
  return (
    <InfoBox type="locked" className={styles['info-box']}>
      <h3>Renewal summary</h3>
      <List className={styles.summary}>
        <ListSubheader>{isImmediate ? 'Immediately' : 'On the 10th of the last lease month'}</ListSubheader>
        <AggregateListItem text="Update rental amount">
          <span>{formatCurrency(rentAmount)}</span>
        </AggregateListItem>
        <AggregateListItem text={managementFeeLabel}>
          <span>{managementFeeText}</span>
        </AggregateListItem>
        <ListSubheader>The following draft invoices will be generated</ListSubheader>
        <AggregateListItem text="Renewal fee">
          <span>{formatCurrency(renewalFee)}</span>
        </AggregateListItem>
        {showDepositTopUp && (
          <AggregateListItem text="Deposit top-up">
            <span>{formatCurrency(depositTopUp)}</span>
          </AggregateListItem>
        )}
      </List>
    </InfoBox>
  )
}

export default NextSteps
